import React, { useEffect, Fragment } from 'react';
import { useLocation } from 'react-router-dom';

//see: https://stackoverflow.com/questions/36904185/react-router-scroll-to-top-on-every-transition

function ScrollToTop({ children }) {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return <Fragment>{children}</Fragment>;
}

export default ScrollToTop;